module.exports = __webpack_public_path__ + "img/footer_doing.f9188784.png";